import { useState } from "react";
import styled from "styled-components";

import { Navigator, useStepper } from "../Stepper";
import { ReactComponent as IconHouse } from "assets/icons/icon-house.svg";
import { ReactComponent as IconCar } from "assets/icons/icon-car.svg";
import { ReactComponent as IconCreditCard } from "assets/icons/icon-credit-card.svg";
import { ReactComponent as IconLoan } from "assets/icons/icon-loan.svg";
import SquareBoxOption from "../components/SquareBoxOption";
import Heading from "components/Heading";

const OPTIONS = [
  {
    id: "home",
    Icon: IconHouse,
    label: "Comprar Casa",
  },
  {
    id: "car",
    Icon: IconCar,
    label: "Comprar Carro",
  },
  {
    id: "credit-card",
    Icon: IconCreditCard,
    label: "Sacar Tarjetas de Crédito",
  },
  {
    id: "loan",
    Icon: IconLoan,
    label: "Pagar Prestamos",
  },
];

const Reason = () => {
  const { getDefault } = useStepper();
  const [selectedOption, setSelectedOption] = useState(
    getDefault("reason") || ""
  );

  return (
    <>
      <Heading title={`¿Por qué desea arreglar su crédito?`} />

      <ListOptions>
        {OPTIONS.map(({ id, Icon, label }) => (
          <li key={`option-${id}`}>
            <SquareBoxOption
              Icon={Icon}
              $selected={selectedOption === id}
              onClick={() => {
                setSelectedOption(id);
              }}
            >
              {label}
            </SquareBoxOption>
          </li>
        ))}
      </ListOptions>

      <Navigator
        $disableContinue={selectedOption.length === 0}
        saveDataHandler={() => selectedOption}
        $continueText="Comenzar Gratis"
      />
    </>
  );
};

export default Reason;

const ListOptions = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
`;
